import { useAuthStore } from '@stores';
import { brokerGiveaway, isCampaignActive } from '@constants';
import { useCountdown } from './useCountdown';

export interface BrokerPromoState {
  eligible: boolean;
  days: number;
  hours: number;
  minutes: number;
}

/**
 * Single source of truth for the broker giveaway promo: whether the banner
 * should show (active campaign + non-staff user + not yet ended) plus the live
 * countdown. The Dashboard uses `eligible` to swap the welcome hero for the
 * banner, and BrokerPromoPanel consumes the same hook, so both stay in sync as
 * the campaign ends. Non-staff = the auth store's `lenders` array is empty.
 */
export function useBrokerPromo(): BrokerPromoState {
  const { lenders } = useAuthStore();
  const { days, hours, minutes, ended } = useCountdown(brokerGiveaway.endsAt);
  const isStaff = (lenders?.length ?? 0) > 0;
  const eligible = !isStaff && isCampaignActive(brokerGiveaway) && !ended;
  return { eligible, days, hours, minutes };
}
